import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import {
  criarTranspFailure,
  criarTranspRequest,
  criarTranspSuccess,
  loadFailureTransp,
  loadRequestTransp,
  loadSuccessTransp,
  selectRequest,
  selectSuccess,
  selectTransportadoraParceiraRequest,
  verificarTranspFailure,
  verificarTranspRequest,
  verificarTranspSuccess,
} from './actions';
import { ITranspSelecionada } from './types';

export function* loadTransp({ payload }: ReturnType<typeof loadRequestTransp>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getTransportadoras&token=${state.auth.token}`,
      {
        parceiros: payload.inscricaoAtiva,
        codCdd: payload.cddAtivo,
      }
    );
    yield put(loadSuccessTransp(response.data.transportadoras));
  } catch (error: any) {
    yield put(loadFailureTransp());
    if (error.response) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      console.error('error.message', error.message);
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    }
  }
}

export function* selectTransp({ payload }: ReturnType<typeof selectRequest>): any {
  const state = yield select();
  const selecionada = state.Transportadoras.data.find(
    (item: ITranspSelecionada) => item.codParceiro === payload.codParceiro
  );

  yield put(selectSuccess(selecionada));
}

export function* selectTransportadoraParceira({
  payload,
}: ReturnType<typeof selectTransportadoraParceiraRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getTransportadorasParceiras&token=${state.auth.token}`,
      {
        parceiros: payload.parceiros,
        codCdd: payload.codCdd,
      }
    );
    yield put(loadSuccessTransp(response.data.transportadoras));
  } catch (error: any) {
    yield put(loadFailureTransp());
    if (error.response) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      console.error('error.message', error.message);
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    }
  }
}

export function* criarTransp({ payload }: ReturnType<typeof criarTranspRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}criaTransportadora&token=${state.auth.token}`,
      {
        inscricaoEstadual: payload.inscricaoAtiva,
        nome: payload.nome,
        cnpj: payload.cnpj,
        codCid: payload.codCid,
      }
    );
    yield put(criarTranspSuccess(response.data));
  } catch (error: any) {
    yield put(criarTranspFailure());

    if (error.response) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      console.error('error.message', error.message);
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    }
  }
}

export function* verificarTransp(payload: ReturnType<typeof verificarTranspRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getTransportadorasDetalhadas&token=${state.auth.token}`
    );
    yield put(verificarTranspSuccess(response.data.transportadoras));
  } catch (error: any) {
    yield put(verificarTranspFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar as transportadoras, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
